// src/components/ConstitutionViewer.js
import React from "react";
import { Document, Page, pdfjs } from "react-pdf";

// Set the workerSrc property to the correct URL for pdf.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const ConstitutionViewer = () => {
  return (
    <div>
      <Document
        file="/constitution.pdf" // Path to the PDF file in the public folder
        onLoadError={console.error}
      >
        <Page pageNumber={1} />
        {/* You can render additional pages if needed */}
      </Document>
    </div>
  );
};

export default ConstitutionViewer;
